import { PaksTargetType } from '@cpak/adp-cpak-quotes-service-models';

export enum PakTab {
  Quote = 'quote',
  Contract = 'contract',
  Prototype = 'prototype',
  All = 'all',
}

export const PakTabToTargetMap = new Map<PakTab, PaksTargetType | undefined>([
  [PakTab.All, undefined],
  [PakTab.Quote, PaksTargetType.quote],
  [PakTab.Contract, PaksTargetType.contract],
  [PakTab.Prototype, PaksTargetType.prototype],
]);

export enum PackAttribute {
  ProcedureType = 'Procedure Type',
  Account = 'Account',
  RevisedFrom = 'Revised From',
}
